<template>
  <div class="root">
    <div class="header-box add-bg">
      <div class="c-header clearfix">
        <div class="header-logo">
          <a href="/">
            <img src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="contact-us">
      <h2>联系我们</h2>
      <p>CONTACT US <i></i></p>
      <div class="map">
        <img src="./images/map.png" alt="图片加载失败">
      </div>
      <ul>
        <li class="left">
          <h2>联系地址</h2>
          <p>地址:重庆市渝北区金开大道西段106号2幢8层3号</p>
        </li>
        <li>
          <h2>联系邮箱</h2>
          <p>商务邮箱:bjjrkf@bajiegroup.com</p>
        </li>
        <li class="left">
          <h2>联系电话</h2>
          <p>客服电话:<span>023-88392602</span></p>
        </li>
        <li>
          <h2>邮政编码</h2>
          <p>邮编:400120</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "contact-us",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 0,
    };
  },
  mounted() {
    this.$bus.$emit("ready");
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>

<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.root {
  background-color: #ffffff;
}
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  background-color: #fff;
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
        &.active {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
      }
    }
  }
}
.contact-us {
  width: 1200px;
  padding-top: 150px;
  padding-bottom: 110px;
  min-height: 400px;
  margin: 0 auto;
  h2 {
    font-size: 34px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #000000;
  }
  p {
    font-size: 16px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #dddddd;
    position: relative;
    i {
      position: absolute;
      width: 62px;
      height: 3px;
      background: url("./images/contact-us.png") no-repeat;
      left: 50%;
      margin-left: -31px;
      bottom: 10px;
    }
  }
  .map {
    padding: 70px 0;
    img {
      width: 100%;
    }
  }
  ul {
    padding: 0 30px;
    height: 520px;
    li {
      width: 460px;
      height: 260px;
      float: left;
      &.left {
        width: 680px;
      }
      h2 {
        font-size: 26px;
        color: #000000;
        height: 120px;
        line-height: 120px;
        width: 460px;
        border-bottom: 2px solid #e8e8e8;
        box-sizing: border-box;
        font-weight: normal;
        text-align: left;
      }
      p {
        font-size: 20px;
        color: #444444;
        height: 120px;
        line-height: 120px;
        text-align: left;
        span {
          color: #ff6900;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// contactUs.vue?699deb00